<template>
  <sl-page>
    <div class='page-filter border-bottom'>
      <Row :gutter="12">
        <Col span="6" :lg="6" :md="8" :sm="8" :xs="24" class="margin-bottom">
        <Input v-model="params.courierName" placeholder="请输入快递员姓名" clearable></Input>
        </Col>
        <Col span="6" :lg="6" :md="8" :sm="8" :xs="24" class="margin-bottom">
          <Input v-model="params.companyIds" placeholder="请输入企业" clearable></Input>
        </Col>
        <Col span="6" :lg="6" :md="8" :sm="8" :xs="24" class="margin-bottom">
        <Select v-model="params.type" clearable placeholder="请选择预警类型">
          <Option :value="item.value" v-for="(item,index) in typeData" :key="'t'+index">{{item.label}}</Option>
        </Select>
        </Col>
        <Col span="6" :lg="6" :md="8" :sm="8" :xs="24" class="margin-bottom">
        <DatePicker v-model="params.dateRange" clearable type="daterange" placement="bottom-start" style="width: 100%;" placeholder="请选择时间范围"></DatePicker>
        </Col>
        <Col span="24" :lg="24" :md="24" :sm="24" :xs="24" class="page-action">
        <div>
          <Button type="primary" icon="ios-search" @click="list()">搜索</Button>
          <Button @click="reset()">重置</Button>
        </div>
        <Button v-permission="'stats_speed_warning_export'" type="primary" @click="exportTable()" style="float: right;">导出</Button>
        </Col>
      </Row>
    </div>
    <div class="pg-bd">
      <sl-table ref="table" :loading="loading" :page="page" :columns="columns" :data="data" @on-selection-change="handleSelect" @on-update="handleChange"></sl-table>
    </div>
    <detail ref="detail"></detail>
  </sl-page>
</template>
<script>
import { createDict } from '@/util/dicts'
import { mileageDisplay } from '../utils'
import global from '@/util/mixin/global'
import detail from './detail'
import { saveFile } from '@/util'
export default {
  mixins: [global],
  components: { detail },

  data() {
    let cols = []

    return {
      columns: [{
          minWidth: 150,
          title: '预警编号',
          key: 'warnNo',
        },
        {
          minWidth: 150,
          title: '姓名',
          key: 'courierName',
        },
        {
          minWidth: 200,
          title: '工号',
          key: 'idcard',
        },
        {
          minWidth: 150,
          title: '所属企业',
          key: 'companyName',
        },
        {
          minWidth: 150,
          title: '车牌号',
          key: 'licenseNo',
        },
        {
          minWidth: 150,
          title: '预警类型',
          render: (h, { row }) => {
            let typeData = [
              { value: 0, label: '低速预警' },
              { value: 1, label: '超速预警' },
            ]
            let s = ''
            typeData.forEach(item => {
              if (String(item.value) === String(row.type)) {
                s = item.label
              }
            })
            return h('div', s)
          }
        },
        {
          minWidth: 180,
          title: '预警产生时间',
          render: (h, { row }) => {
            let s = ''
            if (row.submitTime) {
              s = this.$utils.datetime(row.submitTime)
            } else {
              s = 0
            }
            return h('div', s)
          }
        },
        {
          title: '报警位置',
          key: 'action',
          width: 150,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            let btnH = h('div', [
              h('a', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.detail(params.row)
                  }
                }
              }, '查看')
            ])
            return btnH
          }
        },

      ],
      data: [],
      params: {
        courierName: null,
        companyIds: [],
        type: null,
        dateRange: []
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      modalVisible: false,
      selection: [],

      typeData: [
        { label: '低速预警', value: 0 },
        { label: '超速预警', value: 1 },
      ],
    }
  },

  computed: {
    removeDisable() {
      return this.selection.length == 0
    },
    importUrl() {
      return this.$request.courierImportUrl()
    }
  },
  watch: {
    $route(to, from) {
      this.list()
    }
  },
  created() {
    this.def = { ...this.params }
    this.list()
  },

  methods: {

    handleSearchChange(p) {
      this.params = p
      this.list()
    },

    filterSearch() {
      let search = JSON.parse(JSON.stringify(this.params))

      if (search.dateRange && search.dateRange.length && search.dateRange[0]) {
        search.startDate = this.$utils.date(search.dateRange[0])
        search.endDate = this.$utils.date(search.dateRange[1])
      }
      delete search.dateRange
      
      for (let key in search) {
        if (search[key] === null || search[key] === undefined || search[key] === '') {
          delete search[key]
        }
      }
      return search
    },

    list() {
      let search = this.filterSearch()

      let params = { search: search, pageSize: this.page.pageSize, pageNum: this.page.pageNum }

      this.loading = true
      let data = {"code":0,"msg":"成功","data":{"code":0,"msg":"成功","data":null,"pageSize":10,"pageNum":1,"total":87,"pages":9,"orders":null,"search":null,"searchMap":null,"list":[{"id":44151,"warnNo":"高2004300003","courierId":1352,"scheduleId":null,"intervalId":null,"timeStr":"13:30-18:30","carNo":"30759","licenseNo":"浙A.12343","speed":33.489733740458014,"type":1,"beginTime":"2020-04-30T08:09:08.000+0000","submitTime":"2020-04-30T08:15:00.000+0000","longitude":120.20286666666667,"latitude":30.174206666666667,"locationTime":"2020-04-30T08:14:46.000+0000","startDate":null,"endDate":null,"courierName":"天邮1快递员3","companyName":"天邮科技","idcard":"123456003"},{"id":44150,"warnNo":"高2004300002","courierId":1352,"scheduleId":null,"intervalId":null,"timeStr":"13:30-18:30","carNo":"30759","licenseNo":"浙A.12343","speed":27.18752594594595,"type":1,"beginTime":"2020-04-30T07:40:58.000+0000","submitTime":"2020-04-30T07:55:01.000+0000","longitude":120.20721666666667,"latitude":30.173915,"locationTime":"2020-04-30T07:54:42.000+0000","startDate":null,"endDate":null,"courierName":"天邮1快递员3","companyName":"天邮科技","idcard":"123456003"},{"id":44149,"warnNo":"高2004300001","courierId":1352,"scheduleId":null,"intervalId":null,"timeStr":"13:30-18:30","carNo":"30759","licenseNo":"浙A.12343","speed":23.1004505940594,"type":1,"beginTime":"2020-04-30T07:40:58.000+0000","submitTime":"2020-04-30T07:50:00.000+0000","longitude":120.2077,"latitude":30.17387,"locationTime":"2020-04-30T07:49:39.000+0000","startDate":null,"endDate":null,"courierName":"天邮1快递员3","companyName":"天邮科技","idcard":"123456003"},{"id":44148,"warnNo":"高2004230001","courierId":1352,"scheduleId":null,"intervalId":null,"timeStr":"13:30-18:30","carNo":"30759","licenseNo":"浙A.12343","speed":23.04341244444444,"type":1,"beginTime":"2020-04-23T05:35:55.000+0000","submitTime":"2020-04-23T05:45:00.000+0000","longitude":120.2077,"latitude":30.17387,"locationTime":"2020-04-23T05:44:35.000+0000","startDate":null,"endDate":null,"courierName":"天邮1快递员3","companyName":"天邮科技","idcard":"123456003"},{"id":44147,"warnNo":"高2004220016","courierId":1354,"scheduleId":null,"intervalId":null,"timeStr":"07:00-11:30","carNo":"30761","licenseNo":"浙A.12345","speed":30.553142761506276,"type":1,"beginTime":"2020-04-22T02:48:59.000+0000","submitTime":"2020-04-22T03:30:00.000+0000","longitude":120.20468333333334,"latitude":30.173895,"locationTime":"2020-04-22T03:29:54.000+0000","startDate":null,"endDate":null,"courierName":"天邮2快递员1","companyName":"天邮科技","idcard":"223456005"},{"id":44146,"warnNo":"低2004220015","courierId":1352,"scheduleId":null,"intervalId":null,"timeStr":"07:00-11:30","carNo":"30759","licenseNo":"浙A.12343","speed":0.11591011880376895,"type":0,"beginTime":"2020-04-22T02:49:12.000+0000","submitTime":"2020-04-22T03:30:00.000+0000","longitude":120.22091666666667,"latitude":30.17422,"locationTime":"2020-04-22T03:29:47.000+0000","startDate":null,"endDate":null,"courierName":"天邮1快递员3","companyName":"天邮科技","idcard":"123456003"},{"id":44145,"warnNo":"高2004220014","courierId":1354,"scheduleId":null,"intervalId":null,"timeStr":"07:00-11:30","carNo":"30761","licenseNo":"浙A.12345","speed":31.367039005917157,"type":1,"beginTime":"2020-04-22T02:48:59.000+0000","submitTime":"2020-04-22T03:25:00.000+0000","longitude":120.20553333333334,"latitude":30.173928333333333,"locationTime":"2020-04-22T03:24:51.000+0000","startDate":null,"endDate":null,"courierName":"天邮2快递员1","companyName":"天邮科技","idcard":"223456005"},{"id":44144,"warnNo":"低2004220013","courierId":1352,"scheduleId":null,"intervalId":null,"timeStr":"07:00-11:30","carNo":"30759","licenseNo":"浙A.12343","speed":0.13190517482517483,"type":0,"beginTime":"2020-04-22T02:49:12.000+0000","submitTime":"2020-04-22T03:25:00.000+0000","longitude":120.22091666666667,"latitude":30.17422,"locationTime":"2020-04-22T03:24:51.000+0000","startDate":null,"endDate":null,"courierName":"天邮1快递员3","companyName":"天邮科技","idcard":"123456003"},{"id":44143,"warnNo":"低2004220012","courierId":1352,"scheduleId":null,"intervalId":null,"timeStr":"07:00-11:30","carNo":"30759","licenseNo":"浙A.12343","speed":0.1536863661053775,"type":0,"beginTime":"2020-04-22T02:49:12.000+0000","submitTime":"2020-04-22T03:20:00.000+0000","longitude":120.22091666666667,"latitude":30.17422,"locationTime":"2020-04-22T03:19:47.000+0000","startDate":null,"endDate":null,"courierName":"天邮1快递员3","companyName":"天邮科技","idcard":"123456003"},{"id":44142,"warnNo":"高2004220011","courierId":1354,"scheduleId":null,"intervalId":null,"timeStr":"07:00-11:30","carNo":"30761","licenseNo":"浙A.12345","speed":30.692455065653075,"type":1,"beginTime":"2020-04-22T02:48:59.000+0000","submitTime":"2020-04-22T03:20:00.000+0000","longitude":120.20673333333333,"latitude":30.173868333333335,"locationTime":"2020-04-22T03:19:47.000+0000","startDate":null,"endDate":null,"courierName":"天邮2快递员1","companyName":"天邮科技","idcard":"223456005"}]}}
      Promise.resolve(data).then(resp => {
        this.loading = false
        console.log(resp)
        if (!resp.code) {
          this.data = this.$utils.flat(this.$utils.conv(resp.data.list || [], { duration: 'duration', mileageDisplay }))
          this.page.total = resp.data.total || 0
        }
      })
    },


    reset() {
      this.$utils.fill(this.params, this.def)
      this.list()
    },

    handleUpdate() {
      this.modalVisible = false
      this.list()
    },

    handleChange(pageNum, pageSize) {
      if (this.page.pageNum != pageNum || this.page.pageSize != pageSize) {
        this.page.pageNum = pageNum
        this.page.pageSize = pageSize
        this.list()
      }
    },

    handleSelect(selection) {
      this.selection = selection.map(i => i.id)
    },
    detail(row) {
      this.$refs.detail.init(row)
    },
    exportTable() {
      let search = this.filterSearch()
      let params = { search: search }

      this.loading = true
      this.$request.speedWarnExport(params).then(res => {
        this.loading = false
        if (res.status === 200) {
          saveFile(res)
        } else {
          this.$Message.error('下载失败')
        }
      })
    },
  }
}

</script>
